<template lang="pug">
.generic-wrapper
  .container
    BackButton(to="SettingsDocumentContents")
    
    template()
    h1.title(v-if="id") {{documentContent.name}}
    h1.title(v-else) Neuer {{getPDFTypeName(pdfType)}}
    .sub-headline {{getPDFTypeName(documentContent.pdfType)}}

    .margin-top
      h2.title.is-6 Mögliche Werte
      .email-values(v-if="pdfType !== 'ownerSettlement'")
        b-tag(size="is-medium") 
          div(v-pre) {{Datum Heute}}
        b-tag(size="is-medium") 
          div(v-pre) {{Anreise}}
        b-tag(size="is-medium") 
          div(v-pre) {{Abreise}}
        b-tag(size="is-medium") 
          div(v-pre) {{Gast Anrede}}
        b-tag(size="is-medium") 
          div(v-pre) {{Benutzer Vorname}}
        b-tag(size="is-medium") 
          div(v-pre) {{Benutzer Nachname}}
        b-tag(size="is-medium") 
          div(v-pre) {{Gast Vorname}}
        b-tag(size="is-medium") 
          div(v-pre) {{Gast Nachname}}
        b-tag(size="is-medium") 
          div(v-pre) {{Objekt Name}}
        b-tag(size="is-medium") 
          div(v-pre) {{Objekt Code}}
        b-tag(size="is-medium") 
          div(v-pre) {{Objekt Straße}}
        b-tag(size="is-medium") 
          div(v-pre) {{Objekt PLZ}}
        b-tag(size="is-medium") 
          div(v-pre) {{Objekt Stadt}}
        b-tag(size="is-medium") 
          div(v-pre) {{Erwachsene}}
        b-tag(size="is-medium") 
          div(v-pre) {{Kinder}}
        b-tag(size="is-medium") 
          div(v-pre) {{Übernachtungen}}
        
        template(v-if="pdfType === 'contract' || documentContent.pdfType === 'contract'")
          b-tag(size="is-medium") 
            div(v-pre) {{Mietvertragsnummer}}
          b-tag(size="is-medium") 
            div(v-pre) {{Datum Vertrag zurück}}
        
        template(v-if="pdfType === 'offer' || documentContent.pdfType === 'offer'")
          b-tag(size="is-medium") 
            div(v-pre) {{Angebotsnummer}}
        
        template(v-if="pdfType === 'cancelInvoice' || documentContent.pdfType === 'cancelInvoice'")
          b-tag(size="is-medium") 
            div(v-pre) {{Mietvertragsnummer}}
          b-tag(size="is-medium") 
            div(v-pre) {{Stornierungsnummer}}
     
        .email-values(v-if="pdfType === 'ownerSettlement' || documentContent.pdfType === 'ownerSettlement'")
          b-tag(size="is-medium") 
            div(v-pre) {{Eigentümer Anrede}}
          b-tag(size="is-medium") 
            div(v-pre) {{Eigentümer Name}}

    .two-column
      .column
        h2.title.is-6 PDF Beispiel Vorschau
        template(v-if="booking === null")
          b-field(label="Gastname" label-position="on-border")
            b-autocomplete(
              @input="(e) => searchGuests(e)"
              placeholder="Nachname eines Gastes eingeben ..."
              :keep-first="true"
              :open-on-focus="false"
              :data="guestNameResults"
              field="complete"
              @select="option => selectBooking(option)"
              :clearable="true"
            )
          b-button(type="is-primary") Beispiel Buchung laden
        iframe(v-else ref="pdf-preview").pdf-preview
      .column
        ValidationObserver(v-slot="{ handleSubmit }", ref="form")
          .form.w640
            .card
              .top
                h2.title.is-6 Name 
                ValidationProvider(name="Name" rules="required|min:3" v-slot="{ errors, valid }")
                  b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="name")

                  template(v-if="htmlContent && htmlContent.intro !== undefined")
                    h2.title.is-6 Einleitungstext
                    ValidationProvider(name="Einleitungstext" rules="required|min:1" v-slot="{ errors, valid }")
                      b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        vue-editor(v-model="htmlContent.intro" :editorOptions="editorOptions")
                  
                  template(v-if="htmlContent && htmlContent.middle !== undefined")
                    h2.title.is-6 Mitteltext
                    ValidationProvider(name="Mitteltext" rules="required|min:1" v-slot="{ errors, valid }")
                      b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        vue-editor(v-model="htmlContent.middle" :editorOptions="editorOptions")
                  
                  template(v-if="htmlContent && htmlContent.outro !== undefined")
                    h2.title.is-6 Schlusstext 
                    ValidationProvider(name="Schlusstext" rules="required|min:1" v-slot="{ errors, valid }")
                      b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        vue-editor(v-model="htmlContent.outro" :editorOptions="editorOptions")
                  
                  template(v-if="htmlContent && htmlContent.termsAndConditions !== undefined")
                    h2.title.is-6 AGB-Text 
                    ValidationProvider(name="AGB-Text" rules="required|min:1" v-slot="{ errors, valid }")
                      b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        vue-editor(v-model="htmlContent.termsAndConditions" :editorOptions="editorOptions")
                  
                  .button-wrapper.right.margin-top
                    b-button(v-if="id" type="is-text" @click="cloneDocumentContent()") Neue Version
                    b-button(type="is-light" @click="$router.push({name: 'SettingsDocumentContents' })") Abbrechen
                    b-button(v-if="id" type="is-primary" @click="handleSubmit(updateDocumentContent)") Aktualisieren
                    b-button(v-else type="is-primary" @click="handleSubmit(saveDocumentContent)") Speichern
</template>

<script>
import htmlToPdfmake from "html-to-pdfmake";

export default {
  props: {
    pdfType: {
      type: String
    },
    id: {
      type: [String, Number]
    }
  },
  data() {
    return {
      documentContent: {
        htmlContent: {},
        pdfmakeContent: {}
      },

      guestNameSearchString: "",
      guestNameResults: [],
      booking: null,

      name: null,
      htmlContent: {},
      pdfmakeContent: null,
      templateData: {
        offer: {
          intro: "Hier kommt der Einleitungstext...",
          middle: "Hier kommt der Mitteltext...",
          outro: "Hier kommt der Schlusssatz..."
        },
        contract: {
          intro: "Hier kommt der Einleitungstext...",
          outro: "Hier kommt der Schlusssatz...",
          termsAndConditions: "Hier kommen die Geschäftsbedingungen..."
        },
        cancelInvoice: {
          intro: "Hier kommt der Einleitungstext...",
          outro: "Hier kommt der Schlusssatz..."
        },
        paymentReminder1: {
          intro: "Hier kommt der Einleitungstext...",
          outro: "Hier kommt der Schlusssatz..."
        },
        paymentReminder2: {
          intro: "Hier kommt der Einleitungstext...",
          outro: "Hier kommt der Schlusssatz..."
        },
        reminder: {
          intro: "Hier kommt der Einleitungstext...",
          outro: "Hier kommt der Schlusssatz..."
        },
        ownerSettlement: {
          intro: "Hier kommt der Einleitungstext...",
          outro: "Hier kommt der Schlusssatz..."
        }
      },
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        focus: false,
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            [{ list: "ordered" }, { list: "bullet" }],
            [{ color: [] }],
            [{ align: [] }],
            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  watch: {
    htmlContent: {
      deep: true,
      handler() {
        this.throttleUpdate();
      }
    }
  },
  methods: {
    cloneDocumentContent() {
      this.name += ' Neu';
      this.$router.push({name: 'SettingsDocumentContentsNew', params: {pdfType: this.documentContent.pdfType}});
      // window.location.reload();
    },
    throttleUpdate () { // We return a throttled function
      if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
        this.convertHtmlToPdfmake();
      }, 500);
    },
    convertHtmlToPdfmake() {

      const pdfmakeObject = {}
      for (const [key, value] of Object.entries(this.htmlContent)) {
        pdfmakeObject[key] = htmlToPdfmake(value, {defaultStyles:{p: ''}});
      }
      this.pdfmakeContent = pdfmakeObject;
      
      if (!this.booking) return;
      this.generateOfferPDF();
    },
    async selectBooking(booking) {
      this.booking = await this.$store.dispatch("rentObjectBookings/findOne", {id: booking.id});
      this.convertHtmlToPdfmake();
    },
    async searchGuests(searchString) {
      const bookings = await this.$store.dispatch("rentObjectBookings/search", {searchString: searchString});
      this.guestNameResults = bookings.map(b => {
        return {...b, complete: `#${b.id} | ${b.customer && b.customer.firstName ? b.customer.firstName : '-'} ${b.customer && b.customer.lastName ? b.customer.lastName : '-'}`}
      });
    },
    async generateOfferPDF() {
      const loadingComponent = this.$buefy.loading.open();
      const pdfArraybuffer = await this.$store.dispatch(`rentObjectBookings/${this.id ? this.documentContent.pdfType : this.pdfType}PDFPreview`, {id: this.booking.id, pdfmakeContent: this.pdfmakeContent});
      const pdfBlob = new Blob([pdfArraybuffer], { type: "application/pdf" });
      this.$refs["pdf-preview"].src = URL.createObjectURL(pdfBlob);
      loadingComponent.close();
    },
    getPDFTypeName(t) {
      switch (t) {
        case 'offer':
          return 'Angebotsinhalt'
        case 'contract':
          return 'Vertragsinhalt'
        case 'cancelInvoice':
          return 'Stornierungsrechnungsinhalt'
        case 'reminder':
          return 'Mahnungsinhalt'
        case 'ownerSettlement':
          return 'Eigentümerabrechnungsinhalt'
        case 'paymentReminder1':
          return 'Erinnerung'
        case 'paymentReminder2':
          return 'Mahnung'
        default:
          return 'Unbekannter Inhalt - kontaktieren Sie einen Administrator'
      }
    },
    async saveDocumentContent() {
      await this.$store.dispatch("documentContents/create", {name: this.name, htmlContent: this.htmlContent, pdfmakeContent: this.pdfmakeContent, pdfType: this.pdfType});
      this.$router.push({name: 'SettingsDocumentContents', query: {pdfType: this.pdfType}});
    },
    async updateDocumentContent() {
      await this.$store.dispatch("documentContents/update", {id: this.id, name: this.name, htmlContent: this.htmlContent, pdfmakeContent: this.pdfmakeContent, pdfType: this.documentContent.pdfType});
      this.$router.push({name: 'SettingsDocumentContents', query: {pdfType: this.documentContent.pdfType}});
    }
  },
  async mounted() {
    this.htmlContent = this.templateData[this.pdfType];
    if (this.id) {
      this.documentContent = await this.$store.dispatch("documentContents/findOne", {id: this.id});
      this.htmlContent = this.documentContent.htmlContent;
      this.pdfmakeContent = this.documentContent.pdfmakeContent;
      this.name = this.documentContent.name;
    }
  },
};
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  justify-content: space-between;
}

.pdf-preview {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 280px);
}

.email-values {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>